import { render, staticRenderFns } from "./EmrAdmitOrderImage.vue?vue&type=template&id=0ced1ca7&"
import script from "./EmrAdmitOrderImage.vue?vue&type=script&lang=js&"
export * from "./EmrAdmitOrderImage.vue?vue&type=script&lang=js&"
import style0 from "./EmrAdmitOrderImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports